import { formatDate } from '@utils/common'
import { useEffect, useState } from 'react'

/**
 * Hook for formatting dates that prevents hydration mismatches by not rendering
 * the date during the initial server render. This avoids any client/server
 * mismatches that could occur from timezone differences, since the date is only
 * formatted after the initial client-side hydration.
 */
export function useFormattedDate(
  date: Date,
  formatOptions?: Intl.DateTimeFormatOptions,
  locale?: string
): string | null {
  const [formattedDate, setFormattedDate] = useState<string | null>(null)

  useEffect(() => {
    setFormattedDate(formatDate(date, formatOptions, locale))
  }, [date, formatOptions, locale])

  return formattedDate
}
